<script>
import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {required} from "vuelidate/lib/validators";
import LetterCube from "@/components/LetterCube.vue";
import {CURRENT_USER} from "@/helpers/currentUser";
import {tienDoCongViecModel} from "@/models/QuanLyCongViec/tienDoCongViecModel";
import {groupCongViecModel} from "@/models/QuanLyCongViec/groupCongViecModel";

export default {
  page: {
    title: "Tiến độ công việc",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    LetterCube,
  },
  data() {
    return {
      title: "Quản lý công việc",
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: tienDoCongViecModel.baseJson(),
      modelGroup: groupCongViecModel.baseJson(),
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'fontfamily', 'fontsize', '|',
            'bold', 'italic', 'underline', '|',
            'alignment', '|',
            'uploadImage',
            'link', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "files/upload-ckeditor",
          headers: {
            'Authorization': 'optional_token'
          }
        },
        placeholder: 'Nội dung'
      },
      itemFilter: {
        title: null,
        donViSoan: null,
        nguoiSoan: null,
        trangThai: null,
        loaiVanBan: null
      },
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      filter: null,
      isBusy: false,
      sortDesc: false,
      currentUserName: CURRENT_USER.USERNAME,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '30px', minWidth: '30px'},
          class: "text-center content-capso",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "content",
          label: "Nội dung công việc",
          thStyle: {width: 'auto', minWidth: '300px'},
          class: "content-capso",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: "nguoiThucHien",
          label: "Người thực hiện",
          thStyle: {width: 'auto', minWidth: '100px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
        {
          key: "tuNgayDate",
          label: "Ngày bắt đầu",
          thStyle: {width: 'auto', minWidth: '100px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
        {
          key: "denNgayDate",
          label: "Ngày kết thúc",
          thStyle: {width: 'auto', minWidth: '100px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
        {
          key: "trangThai",
          label: "Trạng thái",
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: 'process',
          label: '',
          thStyle: {width: '150px', minWidth: '150px'},
          class: " text-center btn-process ",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        }
      ],
      optionsUser: [],
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      urlView: `${process.env.VUE_APP_API_URL}files/view/`,
    };
  },
  validations: {
    model: {
      loaiVanBan: {required},
      trangThai: {required},
    },
  },
  async created() {
    this.getUser();
    this.handleGroupDetail();
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  methods: {
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    async handleDelete() {
      if (this.model.id != null && this.model.id) {
        await this.$store.dispatch("cvTienDoStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
            this.$refs.tblList.refresh();
          }
        });
      }
    },
    async getUser() {
      await this.$store.dispatch("userStore/getAll").then(resp => {
        if (resp.resultCode == "SUCCESS") {
          let items = resp.data
          this.optionsUser = items;
        }
        return [];
      });
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        groupId:  this.$route.params.id
        // loaiVanBan: this.itemFilter.loaiVanBan,
        // trangThai: this.itemFilter.trangThai,
        // content: this.itemFilter.title,
        // nguoiSoan: this.itemFilter.nguoiSoan,
        // donViSoan: this.itemFilter.donViSoan
      }
      this.loading = true

      try {
        let promise = this.$store.dispatch("cvTienDoStore/getPagingParams", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    async handleUpdate(id) {
      this.$router.push("/tien-do-cong-viec/" + this.$route.params.id + "/cong-viec/" + id);
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleGroupDetail(id) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("cvGroupStore/getById", this.$route.params.id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          if(res.data == null){
            this.$router.push("quan-ly-cong-viec");
            return;
          }else{
            this.modelGroup = res.data;
            loader.hide();
          }

        }
      });
    },
    async handleDetail(id) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("cvTienDoStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          if(res.data == null){
            this.$router.push("quan-ly-cong-viec");
            return;
          }else{
            this.model = res.data;
            this.showModal = true;
            loader.hide();
          }

        }
      });
    },
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ modelGroup.name }}</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
<!--                <b-button v-b-toggle.collapseSearch variant="light"-->
<!--                          class="btn w-md btn-primary-outline me-2" size="sm">-->
<!--                  <i class="fas fa-caret-down align-middle me-2"></i>-->
<!--                  Tìm kiếm-->
<!--                </b-button>-->
                <router-link
                    type="b-button sm"
                    :to="`/tien-do-cong-viec/${$route.params.id}/cong-viec`"
                    class="btn btn-sm w-md btn-primary"
                    size="sm"
                >
                  <i class="mdi mdi-plus align-middle me-2"></i> Thêm công việc
                </router-link>
              </div>
            </div>
<!--            <b-collapse id="collapseSearch" class="mt-1">-->
<!--              <div class="row">-->
<!--                <div class="col-12">-->
<!--                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">-->
<!--                    &lt;!&ndash; Nội dung &ndash;&gt;-->
<!--                    <div class="flex-grow-1 me-2">-->
<!--                      <label>Từ khoá</label>-->
<!--                      <input-->
<!--                          size="sm"-->
<!--                          type="text"-->
<!--                          name="untyped-input"-->
<!--                          class="form-control"-->
<!--                          v-model="itemFilter.title"-->
<!--                          placeholder="Trích yếu/Số lưu CV/..."-->
<!--                      />-->
<!--                    </div>-->
<!--                    &lt;!&ndash; Đơn vị soạn&ndash;&gt;-->
<!--                    <div class="flex-grow-1 me-2">-->
<!--                      <label>Đơn vị soạn</label>-->
<!--                      <multiselect-->
<!--                          v-model="itemFilter.donViSoan"-->
<!--                          :options="optionsDonVi"-->
<!--                          track-by="id"-->
<!--                          label="ten"-->
<!--                          placeholder="Chọn đơn vị soạn"-->
<!--                          deselect-label="Nhấn để xoá"-->
<!--                          selectLabel="Nhấn enter để chọn"-->
<!--                          selectedLabel="Đã chọn"-->
<!--                      ></multiselect>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; Loại văn bản &ndash;&gt;-->
<!--                    <div class="flex-grow-1 me-2">-->
<!--                      <label>Loại văn bản</label>-->
<!--                      <multiselect-->
<!--                          v-model="itemFilter.loaiVanBan"-->
<!--                          :options="optionsLoaiVanBan"-->
<!--                          track-by="id"-->
<!--                          selectLabel="Nhấn vào để chọn"-->
<!--                          deselectLabel="Nhấn vào để xóa"-->
<!--                          class="helo"-->
<!--                          label="ten"-->
<!--                          placeholder="Chọn loại văn bản"-->
<!--                      ></multiselect>-->
<!--                    </div>-->
<!--                    &lt;!&ndash;  Xử lý &ndash;&gt;-->
<!--                    <div class="flex-grow-0 ms-2">-->
<!--                      <div class="d-flex justify-content-between align-items-center flex-wrap">-->
<!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
<!--                          <b-button @click="handleSearch" variant="light"-->
<!--                                    class="btn w-md btn-primary me-2" size="md">-->
<!--                            <i class="fas fa-search align-middle me-2"></i>-->
<!--                            Tìm kiếm-->
<!--                          </b-button>-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
<!--                          <b-button @click="clearSearch" variant="light"-->
<!--                                    class="btn w-md btn-secondary me-2" size="md">-->
<!--                            <i class="fas fa-redo-alt align-middle me-2"></i>-->
<!--                            Làm mới-->
<!--                          </b-button>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </b-collapse>-->
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <!-- Table -->
                <div class="table-responsive-sm table-responsive">
                  <b-table
                      class="datatables cs-table-vbdi"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-vbd"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(content)="data">
                      <span v-if="data.item.content"> {{ data.item.content }}</span>
                    </template>
                    <template v-slot:cell(nguoiThucHien)="data">
                      <div v-if="data.item.nguoiThucHien"> {{ data.item.nguoiThucHien.fullName }}</div>
                    </template>
                    <template v-slot:cell(trangThai)="data">
                      <span v-if="data.item.trangThai" class="badge px-2 py-1"
                            :class="'bg-' + data.item.trangThai.bgColor">
                            {{ data.item.trangThai.ten }}
                          </span>
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          class="btn btn-detail btn-sm "
                          data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                          @click="handleDetail(data.item.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>

                      <b-dropdown
                          id="dropdown-right"
                          right
                          variant="outline"
                          class="cs-btn-dropdown"
                          menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          ...
                        </template>
                        <b-dropdown-item
                            v-if="currentUserName == data.item.createdBy || (data.item.nguoiThucHien && currentUserName == data.item.nguoiThucHien.userName)"
                            v-on:click="handleUpdate(data.item.id)"
                        >
                          <div
                              class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-edit"
                                data-toggle="tooltip" data-placement="bottom" title="Cập nhật">
                              <i class="fas fa-pencil-alt"></i>
                            </button>
                            <span class="ms-2">Chỉnh sửa</span>
                          </div>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="currentUserName == data.item.createdBy"
                            v-on:click="handleShowDeleteModal(data.item.id)"
                        >
                          <div class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-delete"
                                data-toggle="tooltip" data-placement="bottom" title="Xóa"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                            <span class="ms-2">Xóa</span>
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">
                      <LetterCube></LetterCube>
                    </div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <div>
                  <div class="row mb-2">
                    <div class="col-sm-12 col-md-6">
                      <div style="display: flex; justify-content: start; align-items: center">
                        <div id="tickets-table_length" class="dataTables_length me-4">
                          <label class="d-inline-flex align-items-center">
                            Hiện
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;dòng
                          </label>
                        </div>
                        <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div
                          class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="fw-bold fs-5 text-dark"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showDeleteModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="danger"
                      type="button"
                      class="w-md"
                      v-on:click="handleDelete">
              Xóa
            </b-button>
          </template>
        </b-modal>

        <b-modal
            v-model="showModal"
            centered
            title="Thông tin"
            title-class="fw-bold fs-5 text-dark"
            no-close-on-backdrop
            size="lg"
            hide-footer
        >
          <div>
            <div class="d-flex justify-content-between mb-1">
              <p class="mb-0 fw-medium text-black-2a font-size-20">
                {{ model.content}}
              </p>
            </div>
            <div class="d-flex  mb-1" v-if="model.nguoiThucHien">
              <p class="mb-0 text-primary item-detail-card"> Người thực hiện: </p>
              <p class="mb-0 fw-medium text-black-2a">
                 {{ model.nguoiThucHien.fullName }}
              </p>
            </div>
            <div class="d-flex mb-1" v-if="model.listPhoiHop && model.listPhoiHop.length > 0">
              <p class="mb-0 text-primary item-detail-card"> Người phối hợp: </p>
              <p class="mb-0 fw-medium text-black-2a">
                <span v-for="(value, index) in model.listPhoiHop" :key="index">
                  {{value.fullName}} <span v-if="index < model.listPhoiHop.length - 1">,</span>
                </span>
              </p>
            </div>
            <div class="d-flex mb-1" v-if="model.phoiHop">
              <p class="mb-0 text-primary item-detail-card"> Người phối hợp (Khác): </p>
              <p class="mb-0 fw-medium text-black-2a">
                {{model.phoiHop}}
              </p>
            </div>
            <div class="d-flex mb-1">
              <p class="mb-0 text-primary item-detail-card"> Thời gian: </p>
              <p class="mb-0 fw-medium text-black-2a">
                <span v-if="model.tuNgayDate">{{model.tuNgayDate}} <span v-if="model.tuNgayTime"> {{model.tuNgayTime}}</span></span>
                <span v-if="model.denNgayDate"> - {{model.denNgayDate}} <span v-if="model.denNgayTime"> {{model.denNgayTime}}</span></span>
              </p>
            </div>
            <div class="d-flex mb-1" v-if="model.thongTinThem">
              <p class="mb-0 text-primary item-detail-card"> Thông tin thêm: </p>
              <p class="mb-0 fw-medium text-black-2a">
                {{model.thongTinThem}}
              </p>
            </div>
            <div class="d-flex mb-1" v-if="model.ghiChu">
              <p class="mb-0 text-primary item-detail-card"> Ghi chú: </p>
              <p class="mb-0 fw-medium text-black-2a">
                {{model.ghiChu}}
              </p>
            </div>

<!--            <div class="mt-2">-->
<!--              <hr />-->
<!--              <h5>Báo cáo</h5>-->
<!--              <div>-->
<!--                <div class="mb-2">-->
<!--                  <ckeditor-nuxt v-model="model.content" :config="editorConfig"/>-->
<!--                  </div>-->
<!--              </div>-->

<!--              <div class="d-flex flex-row pe-3">-->
<!--                <img src="https://i.imgur.com/zQZSWrt.jpg" width="40" height="40" class="rounded-circle mr-3" style="margin-right: 10px">-->
<!--                <div class="w-100">-->
<!--                  <div class="d-flex justify-content-between align-items-center" >-->
<!--                    <div class="d-flex flex-row align-items-center"> <span class="mr-2" style="font-weight: bold">Brian selter</span> </div> <small>12h ago</small>-->
<!--                  </div>-->
<!--                  <p class="text-justify comments-comment-text mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</p>-->
<!--                  <div class="d-flex flex-row comment-user-feed">-->

<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          -->
          </div>
          <template #modal-header>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showModal = false">
              Đóng
            </b-button>
<!--            <b-button v-b-modal.modal-close_visit-->
<!--                      size="sm"-->
<!--                      variant="danger"-->
<!--                      type="button"-->
<!--                      class="w-md"-->
<!--                      v-on:click="handleDelete">-->
<!--              Xóa-->
<!--            </b-button>-->
          </template>
        </b-modal>

      </div>
    </div>
  </div>
</template>
<style>
.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  color: #00568C;
  padding-left: 10px;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

</style>
<style>


.show-detail-vbd {
  background-color: #e6f0fb;
  border: 1px solid #e6f0fb;
  border-radius: 5px;
  margin: 10px;
}

@media only screen and (max-width: 768px) {
  .show-detail-vbd {
    margin: 0px;
  }
}

.show-detail-vbd .card-body {
  padding: 0;
}

.show-detail-vbd .card-body .nav-tabs .nav-link {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border: none;
  background: transparent;
  color: #055E8F;
  border-radius: 5px;
}

.show-detail-vbd .card-body .nav-tabs .nav-link.active {
  background: #055E8F;
  color: #fff;
}

.show-detail-vbd .card-body .nav-tabs {
  border-bottom: none;
}

.text-black-2a {
  color: #2a2a2a;
}

.text-black {
  color: #000;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

@media only screen and (max-width: 768px) {

  /* Force table to not be like tables anymore */
  .cs-table-vbdi table,
  .cs-table-vbdi thead,
  .cs-table-vbdi tbody,
  .cs-table-vbdi th,
  .cs-table-vbdi td,
  .cs-table-vbdi tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .cs-table-vbdi thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .cs-table-vbdi  tr {
    border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .cs-table-vbdi  .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .cs-table-vbdi  .table-bordered {
    border: none;
  }

  .cs-table-vbdi  .table-bordered th:first-child,
  .cs-table-vbdi .table-bordered td:first-child {
    border-top: none;
  }

  .cs-table-vbdi .table-bordered th,
  .cs-table-vbdi .table-bordered td {
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  .b-table-vbd > td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  .b-table-details.b-table-vbd > td {
    padding-left: 0% !important;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .b-table-vbd .btn-process {
    padding: 0px !important;
  }

  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  .file-box {
    flex-direction: column;
  }

  /*
  Label the data
  */
  .b-table-vbd > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(2):before {
    content: "Số VB đi";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(3):before {
    content: "Trích yếu";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(4):before {
    content: "Ngày nhập";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(5):before {
    content: "Ngày ký";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(6):before {
    content: "Trạng thái";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(7):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

@media only screen and (max-width: 425px) {
  .b-table-vbd > td {
    padding-left: 25% !important;
  }
}

@media only screen and (max-width: 375px) {
  .b-table-vbd > td {
    padding-left: 30% !important;
  }
}

@media only screen and (max-width: 320px) {
  .b-table-vbd > td {
    padding-left: 35% !important;
  }
}

.cs-close-tabs {
  position: relative;
}

.item-close-tabs {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-close-tabs:hover {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  width: 30px;
  height: 30px;
}

.item-icon {
  transform: rotate(135deg);
  color: #fff;
  width: 24px;
  height: 26px;
  position: absolute;
  top: 1px;
  right: -1px;
}

.item-detail-card{
  min-width: 120px;
}

.comments-card {
  background-color: #fff;
  border: none
}



.comments-c-badge {
  background-color: #35b69f;
  color: white;
  height: 20px;
  font-size: 11px;
  width: 92px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px
}

.comments-comment-text {
  font-size: 13px
}

.comments-wish {
  color: #35b69f
}

.comments-user-feed {
  font-size: 14px;
  margin-top: 12px
}

</style>
